module.exports = __webpack_public_path__ + "static/media/highlights-section-img_small.bf4a459a.png";